import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const tabsDefaultVariants = {
  "size": "md",
  "variant": "line"
}
const tabsCompoundVariants = [
  {
    "size": "md",
    "variant": "line",
    "css": {
      "trigger": {
        "h": "10",
        "minW": "10",
        "textStyle": "text.xlarge",
        "px": 0,
        "_vertical": {
          "h": "auto",
          "minW": 12
        }
      },
      "content": {
        "pt": 3,
        "px": 4
      }
    }
  },
  {
    "size": "md",
    "variant": "textLine",
    "css": {
      "trigger": {
        "h": "10",
        "minW": "10",
        "fontWeight": "bold",
        "px": 0,
        "_vertical": {
          "h": "auto",
          "minW": 12
        }
      },
      "content": {
        "pt": 3
      }
    }
  },
  {
    "size": "md",
    "variant": "enclosed",
    "css": {
      "list": {
        "p": "4px",
        "_vertical": {
          "height": "fit-content!",
          "py": "1"
        }
      },
      "trigger": {
        "h": "33px",
        "minW": "160px",
        "textStyle": "headings.small",
        "py": "4px",
        "&:not(:first-child)": {
          "ml": "6px"
        }
      },
      "indicator": {
        "height": "var(--height)",
        "width": "var(--width)"
      }
    }
  },
  {
    "size": "md",
    "variant": "longShort",
    "css": {
      "list": {
        "p": "4px",
        "_vertical": {
          "height": "fit-content!",
          "py": "1"
        }
      },
      "trigger": {
        "h": "33px",
        "minW": "0",
        "textStyle": "headings.small",
        "py": "4px",
        "&:not(:first-child)": {
          "ml": "6px"
        }
      },
      "indicator": {
        "height": "var(--height)",
        "width": "var(--width)"
      }
    }
  },
  {
    "size": "md",
    "variant": "enclosed2",
    "css": {
      "list": {
        "p": "4px",
        "_vertical": {
          "height": "fit-content!",
          "py": "1"
        }
      },
      "trigger": {
        "h": "22px",
        "minW": "56.5px",
        "textStyle": "text.small",
        "py": "4px",
        "&:not(:first-child)": {
          "ml": "4px"
        },
        "_selected": {
          "textStyle": "headings.xsmall"
        }
      },
      "indicator": {
        "height": "var(--height)",
        "width": "var(--width)"
      }
    }
  },
  {
    "size": "md",
    "variant": "enclosed3",
    "css": {
      "list": {
        "minH": "11",
        "py": "6px",
        "px": "2",
        "_vertical": {
          "height": "fit-content!",
          "py": "1"
        }
      },
      "trigger": {
        "textStyle": "styleTitle.xsmall",
        "py": 2,
        "px": 4,
        "&:not(:first-child)": {
          "ml": 2
        }
      },
      "indicator": {
        "height": "var(--height)",
        "width": "var(--width)"
      }
    }
  }
]

const tabsSlotNames = [
  [
    "root",
    "tabs__root"
  ],
  [
    "list",
    "tabs__list"
  ],
  [
    "trigger",
    "tabs__trigger"
  ],
  [
    "content",
    "tabs__content"
  ],
  [
    "indicator",
    "tabs__indicator"
  ]
]
const tabsSlotFns = /* @__PURE__ */ tabsSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, tabsDefaultVariants, getSlotCompoundVariant(tabsCompoundVariants, slotName))])

const tabsFn = memo((props = {}) => {
  return Object.fromEntries(tabsSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const tabsVariantKeys = [
  "variant",
  "size"
]
const getVariantProps = (variants) => ({ ...tabsDefaultVariants, ...compact(variants) })

export const tabs = /* @__PURE__ */ Object.assign(tabsFn, {
  __recipe__: false,
  __name__: 'tabs',
  raw: (props) => props,
  variantKeys: tabsVariantKeys,
  variantMap: {
  "variant": [
    "text",
    "line",
    "textLine",
    "longShort",
    "enclosed",
    "enclosed2",
    "enclosed3"
  ],
  "size": [
    "md"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, tabsVariantKeys)
  },
  getVariantProps
})